// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"172980a7aa238be835bf","4362":"5ea27e5c9dd48442fdad"}[chunkId] + ".css";
};